<template>
  <div class="apartments">
    <MobileTable
      v-model:selection="store.state.apartment.selectedApartments"
      :label="$route.name"
      :columns="apartment.columns"
      :data="store.state.apartment.apartments"
    />
    <DesktopTable
      v-model:selection="store.state.apartment.selectedApartments"
      :label="$route.name"
      :columns="apartment.columns"
      :data="store.state.apartment.apartments"
    />
    <Actions :items="apartment.actions" />
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import Actions from "../../components/shared/Actions.vue";
import MobileTable from "../../widgets/tables/MobileTable";
import DesktopTable from "../../widgets/tables/DesktopTable";
import { onBeforeMount, reactive } from "vue";
import store from "../../store";
import { openMode, actions } from "../../constants";

export default {
  components: { MobileTable, DesktopTable, Actions },

  setup() {
    const router = useRouter();
    const route = useRoute();

    const onCreate = () => {
      store.commit("setOpenMode", openMode.CREATE);
      router.push("/apartamentos/nuevo");
    };
    const onModify = () => {
      if (store.state.apartment.selectedApartments.length !== 1) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setOpenMode", openMode.MODIFY);
        router.push("/apartamentos/modificar");
      }
    };
    const onRemove = async () => {
      if (store.state.apartment.selectedApartments.length !== 1) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setLoading", true);
        const response = await store.dispatch(
          actions.apartmentActions.delete,
          store.state.apartment.selectedApartments[0].id
        );
        if (response.ok) {
          store.commit("setSelectedApartments", []);
          await store.dispatch(
            actions.apartmentActions.findAll,
            store.state.general.selectedBuilding
          );
          store.commit("setLoading", false);
        } else {
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: response.message,
            life: 5000,
          });
          store.commit("setLoading", false);
        }
      }
    };

    const apartment = reactive({
      columns: [
        {
          field: "towerName",
          header: "Torre",
          sort: true,
        },
        {
          field: "number",
          header: "Número",
          sort: true,
        },
        {
          field: "bedrooms",
          header: "Habitaciones",
          sort: true,
        },
        {
          field: "apportionment",
          header: "Coeficiente",
          sort: true,
        },
        {
          field: "totalDebt",
          header: "Deuda",
          sort: true,
          currency: true,
        },
      ],
      actions: [
        {
          name: "Nuevo",
          action: onCreate,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/apartamentos/nuevo"),
        },
        {
          name: "Modificar",
          action: onModify,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/apartamentos/modificar"),
        },
        {
          name: "Eliminar",
          action: onRemove,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/apartamentos/modificar"),
        },
      ],
    });

    onBeforeMount(async () => {
      store.commit("setLoading", true);
      store.commit("setSelectedApartments", []);
      const finded = store.state.general.breadcrumbs.find(
        (item) => item.to === route.path
      );
      if (!finded)
        store.commit("addBreadcrumb", { label: route.name, to: route.path });
      await store.dispatch(
        actions.apartmentActions.findAll,
        store.state.general.selectedBuilding
      );
      store.commit("setLoading", false);
    });

    return { store, apartment };
  },
};
</script>

<style scoped></style>
